import type { QueryClient } from "@tanstack/react-query";
import { getCurrentUserInfoQueryKey, getMySpendQueryKey } from "@/api";

/**
 * Re-read budget (GET /auth/me) and spend after AI work, so the sidebar ring, budget banner and Usage page catch
 * up (frontend/ refreshed its profile after each reply and on budget_exceeded).
 */
export function refreshBudget(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: getCurrentUserInfoQueryKey() }),
    queryClient.invalidateQueries({ queryKey: getMySpendQueryKey() }),
  ]);
}
